export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/packet.worker.674b7438.js");
}
